const { CUSTOM_PARTNER_YTM_ID, CUSTOM_ALFA_YTM_ID, CUSTOM_YTM_ID } = process.env;

const YMCounters = [CUSTOM_PARTNER_YTM_ID, CUSTOM_ALFA_YTM_ID, CUSTOM_YTM_ID];

const antiFlicker = `<!-- Anti-flicker snippet (recommended)  -->
<style>.async-hide { opacity: 0 !important} </style>
<script>(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
(a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
})(window,document.documentElement,'async-hide','dataLayer',4000,
{'GTM-KC29CH2':true});</script>
`;

const alfaMessage =
    '<script defer src="https://sensemachine.pro/static/pageWatcher.js?version3"></script>';

const varioqubAntiFlickerCode = counterId => `<!-- Anti-flicker snippet (Varioqub) -->
<style>.varioqub-antiflicker {opacity: 0 !important;}</style>
<script>
    (function(a,n,t,i,f,li,c,k,e,r){
        a[t]=a[t]||function(){(a[t].a=a[t].a||[]).push(arguments)};n.classList.add(i);c=function(){n.classList.remove(i)};li.callback=c;a[t].antiFlicker=li;setTimeout(c,f);
    })(window, document.documentElement, 'ymab', 'varioqub-antiflicker', 4000, { 'metrika.${counterId}': true });
</script>`;

const varioqubAntiFlicker = () =>
    YMCounters.map(counterId => varioqubAntiFlickerCode(counterId)).join('\n');

module.exports = {
    antiFlicker,
    alfaMessage,
    varioqubAntiFlicker
};
